import { useAction } from "@/hooks/shared";
import { listCompanyBenchmarksHandler } from "@/services";

export const useListCompanyBenchmarks = () => useAction(listCompanyBenchmarksHandler);
